<template>
    <main class="main__restore__your__account__wrapper">
        <div class="signin__flow__individual__wrap">
            <div class="restore__your__account__wrapper">
                <div class="logo__wrapper">
                    <img :src="logo" alt="EESA App" class="rlms-mx-auto" />
                </div>
                <div class="title__cover__block">
                    <h3 class="title">Restore your Account</h3>
                    <div class="title__shortnote__cover">
                        <p>
                            We regret to inform you that your account has been deleted. Below is the remaining time
                            left.
                            After this period, your account deletion will become permanent. If you want to restore your
                            account,
                            click on the button below.
                        </p>
                    </div>
                </div>
                <div v-if="countdownVisible" id="countdown">
                    <ul>
                        <li><span class="days">{{ countdown.days }}</span> Days</li>
                        <li><span class="hours">{{ countdown.hours }}</span> Hours</li>
                        <li><span class="minutes">{{ countdown.minutes }}</span> Minutes</li>
                        <li><span class="seconds">{{ countdown.seconds }}</span> Seconds</li>
                    </ul>
                </div>
            </div>

            <div class="signin__form__wrapper">
                <form @submit.prevent="restoreAccount">
                    <div class="form__sign__btn">
                        <button type="submit" class="sign__in__btn">Restore Your Account</button>
                    </div>
                </form>
                <div class="restore__back__btn">
                    <!-- <router-link to="/">Back</router-link> -->
                </div>
                <div class="signin__options__box">
                    <span class="signin__label">Need an EESA APP Account?</span>
                    <span class="create__account__link">
                        <router-link to="/register">Create an account</router-link>
                    </span>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '@/services/axios'
import { handleError } from '@/utils/handleError'
import logo from '@/assets/images/logo2.png'
import { showToast } from '@/utils/swal';
import { useLoaderStore } from '@/stores/loader';

const route = useRoute();
const router = useRouter();
const loader = useLoaderStore();

const token = route.params.token;
const countdown = ref({ days: 0, hours: 0, minutes: 0, seconds: 0 });
const countdownInterval = ref(null);
const countdownVisible = ref(false);


const fetchDeletedDate = async () => {
    try {
        loader.show();

        const res = await api.get(`/restore-account/${token}`);
        const deletedAt = new Date(res?.data?.data?.date);

        countdownInterval.value = setInterval(() => {
            const now = new Date();
            const diff = deletedAt.getTime() - now.getTime();

            if (diff <= 0) {
                clearInterval(countdownInterval.value);
                countdownVisible.value = false;
                return;
            }

            const seconds = Math.floor((diff / 1000) % 60);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));

            countdown.value = { days, hours, minutes, seconds };
            countdownVisible.value = true;
        }, 1000);

    } catch (error) {
        router.push('/');
        
        handleError(error);
    } finally {
        loader.hide();
    }
};

const restoreAccount = async () => {
    try {
        loader.show();

        await api.post(`/restore-account/${token}`);

        router.push('/login');

        showToast({
            icon: 'success',
            title: 'Success',
            text: 'Your account have been restored successfully.',
        })
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

onMounted(fetchDeletedDate);
</script>